import { environment } from '../../environments/environment';

export const Global = {
  url: environment.apiUrl
}
